var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#fff;}.cls-3{fill:#f16529;}.cls-4{fill:#e44d26;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.46.5h4.45v4.41h4.1V.5h4.45v13.34h-4.45v-4.45h-4.06v4.45h-4.49m18.87-8.89h-3.93V.5h12.32v4.45h-3.94v8.89h-4.45M50.68.5h4.66l2.86,4.7,2.86-4.7h4.66v13.34h-4.45v-6.61l-3.11,4.8-3.11-4.8v6.61h-4.37M67.92.5h4.45v8.93h6.3v4.41h-10.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m21.31,91.57L14.92,19.95h70.15l-6.38,71.58-28.75,7.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m50,93.41V25.83h28.68l-5.47,61.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.96,34.59h22.04v8.78h-12.41l.81,8.99h11.6v8.76h-19.65m.39,4.41h8.82l.62,7.02,9.82,2.63v9.17l-18.02-5.03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m71.97,34.59h-22v8.78h21.19m-.79,8.99h-20.4v8.78h10.83l-1.02,11.41-9.8,2.63v9.13l17.98-4.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.669e6ed43fdc4665fe5ef5b8cc310741.svg";
export { ForwardRef as ReactComponent };